"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreciosOmieFrontend = void 0;
const ajax_1 = require("./ajax");
const d3charts_1 = require("./d3charts");
class PreciosOmieFrontend {
    constructor(ajaxUrl) {
        this.spinnerId = "omie-loading-spinner";
        this.chartContainerId = "mn_precios_omie_chart";
        this.ajaxClient = new ajax_1.PreciosOmieAjaxClient(ajaxUrl);
        this.d3Charts = new d3charts_1.D3Charts();
        //Obtain data and render it
        this.init();
    }
    async init() {
        // Check if the charts container exists or mn_high_price or mn_low_price or mn_avg_price
        const chartContainer = document.getElementById(this.chartContainerId);
        const highest_price_container = document.getElementById('mn_high_price');
        const lowest_price_container = document.getElementById('mn_low_price');
        const average_price_container = document.getElementById('mn_avg_price');
        if (!chartContainer && !highest_price_container && !lowest_price_container && !average_price_container) {
            return;
        }
        // Usar la fecha actual en la zona horaria de España (Europa/Madrid)
        const date = new Date();
        const formattedDate = date.toISOString().split("T")[0]; // YYYY-MM-DD
        const response = await this.ajaxClient.getData(formattedDate);
        if (response.success && Array.isArray(response.data)) {
            this.pricesData = response.data;
            // Initialize chart and metrics widgets
            this.renderChartForDate(formattedDate);
            this.updateMetricsWidgets(formattedDate);
        }
        else {
            this.pricesData = [];
        }
        return this.pricesData;
    }
    /**
     * Fetch data for a given date and render the chart.
     * @param date Date string in 'YYYY-MM-DD' format
     */
    async renderChartForDate(date) {
        this.showSpinner();
        try {
            const response = this.pricesData;
            //console.log("renderChartForDate", response);
            this.hideSpinner();
            if (response[0].data && response[0].data !== "") {
                this.d3Charts.createChart(JSON.parse(response[0].data));
                // Debounce function to limit how often the resize handler runs
                let resizeTimeout;
                const resizeHandler = () => {
                    const container = document.getElementById(this.chartContainerId);
                    if (container) {
                        container.innerHTML = "";
                    }
                    this.d3Charts.createChart(JSON.parse(response[0].data));
                };
                window.addEventListener("resize", () => {
                    if (resizeTimeout !== undefined) {
                        clearTimeout(resizeTimeout);
                    }
                    resizeTimeout = window.setTimeout(resizeHandler, 200);
                });
            }
            else {
                this.showError(response.message || "Error loading data.");
            }
        }
        catch (error) {
            this.hideSpinner();
            this.showError("AJAX request failed.");
        }
    }
    async updateMetricsWidgets(date) {
        const highest_price_container = document.getElementById('mn_high_price');
        const lowest_price_container = document.getElementById('mn_low_price');
        const average_price_container = document.getElementById('mn_avg_price');
        const response = this.pricesData;
        //console.log("updateMetricsWidgets", response);
        if (highest_price_container && response[0].max_price) {
            highest_price_container.innerHTML = (parseFloat(response[0].max_price)).toFixed(6).toString().replace(".", ",");
        }
        if (lowest_price_container && response[0].min_price) {
            lowest_price_container.innerHTML = (parseFloat(response[0].min_price)).toFixed(6).toString().replace(".", ",");
        }
        if (average_price_container && response[0].average_price) {
            average_price_container.innerHTML = (parseFloat(response[0].average_price)).toFixed(6).toString().replace(".", ",");
        }
    }
    showSpinner() {
        let spinner = document.getElementById(this.spinnerId);
        let chartContainer = document.getElementById(this.chartContainerId);
        if (!spinner && chartContainer) {
            spinner = document.createElement("div");
            spinner.id = this.spinnerId;
            spinner.style.position = "fixed";
            spinner.style.top = "50%";
            spinner.style.left = "50%";
            spinner.style.transform = "translate(-50%, -50%)";
            spinner.style.zIndex = "9999";
            spinner.innerHTML = `<div style="border: 8px solid #f3f3f3; border-top: 8px solid #3498db; border-radius: 50%; width: 60px; height: 60px; animation: spin 1s linear infinite;"></div>
            <style>
            @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
            </style>`;
            chartContainer.appendChild(spinner);
            spinner.style.display = "block";
        }
    }
    hideSpinner() {
        const spinner = document.getElementById(this.spinnerId);
        if (spinner) {
            spinner.style.display = "none";
        }
    }
    showError(message) {
        let container = document.getElementById(this.chartContainerId);
        if (!container) {
            container = document.createElement("div");
            container.id = this.chartContainerId;
            document.body.appendChild(container);
        }
        container.innerHTML = `<div style="color: red; font-weight: bold;">${message}</div>`;
    }
}
exports.PreciosOmieFrontend = PreciosOmieFrontend;
// Example usage (to be removed/commented for production):
// const frontend = new PreciosOmieFrontend("AJAX_URL", "NONCE");
// frontend.renderChartForDate("2024-06-01");
